import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
//import {Configuration} from 'src/app/Utilities/configurations';
// var Configuration = require('src/assets/app-config.json');
import { IOrderNote } from '../models/IOrderNote';
import { configuration } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class PatientSearchService {


  queryUrl: string = 'Patient/search?';

  constructor(private http: HttpClient) { }

  search(terms: Observable<string>) {
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => this.searchEntries(term));
  }

  // searchEntries(term) {
  //   const posteddata={
  //     inputdata:JSON.stringify(term)
  //   }  
  //   return this.http
  //     .get(configuration.apiUrl + this.queryUrl + posteddata)
  //     .map(res => res);
  // }

  searchEntries(term) {
    const posteddata={
      inputdata:JSON.stringify(term)
    }  
      return this.http.post(`${configuration.apiUrl + 'Patient/search'}`, posteddata, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }
  searchCCDAEntries(term, fromdd, todd ) {
    const posteddata={
      inputdata:JSON.stringify(term)
    }  
      return this.http.post(`${configuration.apiUrl + 'Patient/CCDASearch'}?fromdate=${fromdd}&&todate=${todd}`, posteddata, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }

  createOrderNote(orderNote: IOrderNote): Observable<any> {
    return this.http.post<number>
      (`${configuration.clinicapiUrl + 'Encounter/CreateOrderNote'}?UserId=admin`, orderNote, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }
}
